import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import FormikButton from '../../../common/formik/FormikButton';
import FormikGrid from '../../../common/formik/FormikGrid';
import FormikTextField from '../../../common/formik/FormikTextField';
import { ProductRelease } from '../Product.interface';
import {
  useCreateProductRelease,
  useUpdateProductRelease
} from '../Product.hooks';

export interface CreateEditProductReleaseDialogProps {
  open: boolean;
  productId: number;
  productRelease?: ProductRelease | null;
  onCancel?: () => void;
  onSubmit?: (productRelease: ProductRelease) => void;
}

const CreateEditProductReleaseDialog: React.FC<CreateEditProductReleaseDialogProps> = ({
  open,
  productRelease,
  productId,
  onCancel,
  onSubmit
}) => {
  const formikRef = useRef<FormikValues>();
  const onSubmitRef = useRef(onSubmit);
  const {
    createdRelease,
    createReleaseError,
    createRelease
  } = useCreateProductRelease(productId);
  const {
    updatedRelease,
    updateReleaseError,
    updateRelease
  } = useUpdateProductRelease(productId, productRelease?.id || 0);

  useEffect(() => {
    if (createdRelease) {
      onSubmitRef.current?.(createdRelease);
    }
    formikRef.current?.setSubmitting(false);
  }, [createdRelease]);
  useEffect(() => {
    if (updatedRelease) {
      onSubmitRef.current?.(updatedRelease);
    }
    formikRef.current?.setSubmitting(false);
  }, [updatedRelease]);
  return (
    <Dialog maxWidth='xs' open={open} onClose={onCancel}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{
          name: productRelease?.name || '',
          description: productRelease?.description || ''
        }}
        validationSchema={Yup.object({
          name: Yup.string().required('Required')
        })}
        onSubmit={(release: any) => {
          if (productRelease) {
            updateRelease({ id: productRelease.id, ...release });
          } else {
            createRelease(release);
          }
        }}
      >
        <Form autoComplete='off'>
          <DialogTitle>
            {productRelease ? 'Update' : 'Create'} Product Release
          </DialogTitle>
          <DialogContent>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='name'
                label='Release Name'
              />
              <FormikTextField
                type='text'
                name='description'
                label='Description'
              />
            </FormikGrid>
            {createReleaseError && (
              <Alert severity='error'>{`Error occurred. ${createReleaseError.message}`}</Alert>
            )}
            {updateReleaseError && (
              <Alert severity='error'>{`Error occurred. ${updateReleaseError.message}`}</Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>{productRelease ? 'Update' : 'Create'}</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default CreateEditProductReleaseDialog;
